<template>
    <!-- template seatrch view -->
    <div class="result-reponse">
        <div class="container-custom">
            <div class="resultes-reponses-wrapper">
                <div v-if="isMobile" class="result-bloc__header">
                    <h1 class="heading-1 result-bloc__heading">
                        {{ result.total }} Résultats de la recherche
                    </h1>

                    <div class="result-bloc-header">
                        <h2 :class="showFilter ? 'result-filter__heading result-bloc-header__heading focus' : 'result-filter__heading result-bloc-header__heading'"
                            @click="toggleShow('filter')">
                            <IconFilter />Filtres
                        </h2>
                        <SortSelect :options="sorted" v-model="currentFilters.sort" @change="onSelect" />
                    </div>
                </div>
                <div class="result-filter-wrapper" :class="showFilter ? 'is-active-filters' : ''">
                    <div class="reset-filters" v-if="showDeleteFilters">
                        <span @click="resetFilters">Supprimer les filtres</span>
                    </div>
                    <div class="result-filter">
                        <h2 v-if="!isMobile" class="result-filter__heading">
                            <IconFilter />Filtres
                        </h2>

                        <FacetFilter
                            title="Par Revue"
                            :facet="getFacetRevue"
                            v-model="currentFilters.nomrevues"
                            @change="onSelectRevue" />

                        <FacetFilter
                            title="Par Mot clé"
                            :facet="getFacetMotCle"
                            v-model="currentFilters.motcle"
                            @change="onSelect" />

                        <FacetFilter
                            title="Par Spécialité"
                            :facet="getFacetSpecialite"
                            v-model="currentFilters.specialite"
                            @change="onSelect" />
                    </div>
                </div>
                <div id="result-bloc" class="result-bloc" v-if="result">
                    <div v-if="!isMobile" class="result-bloc__header">
                        <h1 class="heading-1 result-bloc__heading">
                            {{ result.total }} Résultats de la recherche
                        </h1>
                        <SortSelect :options="sorted" v-model="currentFilters.sort" @change="onSelect" v-if="result.results.length > 0" />
                    </div>

                    <div v-if="result.results.length > 0">
                        <div class="result-list" v-for="item in result.results" :key="item.id">
                            <h4>{{ item.title }}</h4>
                            <p>{{ trimChapo(item.chapo) }}</p>
                            <div class="revue__detail">
                                <p>{{ item.nomrevue }}</p>
                                <div class="author">
                                    <span v-for="(auteur, index) in item.auteurs" :key="auteur.firstName">
                                        <span v-if="index < item.auteurs.length - 1">{{ auteur.firstName }} {{ auteur.lastName }}, </span>
                                        <span v-else>{{ auteur.firstName }} {{ auteur.lastName }}</span>
                                    </span>
                                </div>
                                <p v-if="item.millesime">Publié le : {{ getDate(item.date_publication) }} • Vol : {{ item.millesime }} • N° : {{ item.numparution }} • Page(s) : {{ item.pagedebutfin }}</p>
                                <p v-else>Publié le : {{ getDate(item.date_publication) }} • N° : {{ item.numparution }} • Page(s) : {{ item.pagedebutfin }}</p>

                            </div>
                            <div class="result-list--btn" >
                                <button v-if="item.isAbonne" class="btn btn-red btn-small" @click="viewPdf" :data-id="item.id" :data-title="item.title" :data-revue="item.nomrevue">Voir</button>
                                <button v-if="item.isAbonne" class="btn btn-red btn-download btn-small" @click="downloadPDF" :data-id="item.id" :data-title="item.title" :data-revue="item.nomrevue">Télécharger
                                    <svg id="square-download" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                        viewBox="0 0 16 16">
                                        <path id="Tracé_264" data-name="Tracé 264"
                                            d="M8,12a.908.908,0,0,0,.7-.3L14.4,6,13,4.6l-4,4V0H7V8.6l-4-4L1.6,6l5.7,5.7A.908.908,0,0,0,8,12Z"
                                            fill="#fff" />
                                        <path id="Tracé_265" data-name="Tracé 265"
                                            d="M14,14H2V11H0v4a.945.945,0,0,0,1,1H15a.945.945,0,0,0,1-1V11H14Z"
                                            fill="#fff" />
                                    </svg>
                                </button>
                                <button class="btn btn-gray btn-small btn-export" @click="showPopinExport(item.id, item.title)">Exporter les références</button>
                            </div>
                        </div>
                        <div class="result_popin" v-if="showPopin">
                            <div class="result_popin__wrapper">
                                <div class="result_popin__header">
                                    Exporter les références :
                                    <span class="popin_close" @click="closePopinExport"></span>
                                </div>
                                <div class="result_popin__content">
                                    <button class="btn btn-gray btn-small btn-export" @click="exportFormat($event,'ris')">Format RIS</button>
                                    <button class="btn btn-gray btn-small btn-export" @click="exportFormat($event,'bib')">Format BIB</button>
                                    <button class="btn btn-gray btn-small btn-export" @click="exportFormat($event,'enw')">Format ENW</button>
                                    <button class="btn btn-gray btn-small btn-export" @click="exportFormat($event,'txt')">Format TXT</button>
                                </div>
                            </div>
                        </div>
                        <Pagination :totalPages="totalPages" :perPage="perPage" :currentPage="currentPage" @pagechanged="onPageChange" />
                    </div>
                    <div v-else> Aucun résultat de correspond à la recherche</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import moment from "moment"
import Pagination from '@/components/recherche/PaginationResult.vue'
import FacetFilter from '@/components/recherche/FacetFilter.vue'
import IconFilter from '@/components/recherche/IconFilter.vue'
import SortSelect from '@/components/recherche/SortSelect.vue'

export default {
    components: {
        Pagination, FacetFilter, IconFilter, SortSelect
    },
    props: ['refresh'],
    watch: {
        refresh(refresh) {
            if (refresh) {
                this.currentFilters.rubrique = [];
                this.currentFilters.specialite = [];
                this.currentFilters.motcle = [];
                this.search()
            }
        }
    },
    data() {
        return {
            showFacetRevue: true,
            showFacetMotCle: false,
            showFacetSpecialite: false,
            showFilter: false,
            result: {
                total: 0,
                results: [],
                availableFacets: []
            },
            currentPage: 1,
            totalPages: 0,
            perPage: 100,
            currentFilters: null,
            sorted: {
                "": "Pertinence",
                "-date": "Du plus récent au plus ancien",
                "date": "Du plus ancien au plus récent",
                "title": "Ordre alphabetique (de A à Z)",
                "-title": "Ordre antialphabétique (de Z à A)",
                "page": "Page croissante",
                "-page": "Page décroissante"
            },
            popin: {
                id: null,
                title: null
            },
            showPopin: false,
            showDeleteFilters: false
        }
    },
    computed: {
        ...mapState([
            'auth'
        ]),
        ...mapGetters([
            'getProfile',
            'getSearchFilters',
            'getAbonnements',
            'getAbonnementsStartDates',
            'getAbonnementsEndDates',
            'getPublications'
        ]),
        getFacets() {
            if (this.result && this.result.availableFacets) {
                return this.result.availableFacets
            }
            return false
        },
        getFacetMotCle() {
            if (this.result && this.result.availableFacets) {
                return this.result.availableFacets.filter(f => f.name === 'motcle')[0]
            }
            return false
        },
        getFacetRevue() {
            if (this.result && this.result.availableFacets) {
                let availableNomRevue = this.result.availableFacets.filter(f => f.name === 'nomrevue')[0];
                if (availableNomRevue != undefined) {
                    this.getPublications.forEach(element => {
                        let facet = availableNomRevue.searchFacetValue.filter(f => f.name == element.key);
                        if (facet.length == 0 || facet.length == undefined) {
                            availableNomRevue.searchFacetValue.push({
                                "name": element.key,
                                "label": element.label
                            });
                        }
                    })

                    return availableNomRevue;
                }
                return this.result.availableFacets.filter(f => f.name === 'nomrevue')[0]
            }
            return false
        },
        getFacetSpecialite() {
            if (this.result && this.result.availableFacets) {
                return this.result.availableFacets.filter(f => f.name === 'specialite')[0]
            }
            return false
        },
        isMobile() {
            return this.$vssWidth < 992
        },
    },
    methods: {
        ...mapActions([
            'setOnLoad',
            'setSearchFilters'
        ]),
        findFacet(name) {
            return this.result.availableFacets?.find(f => f.name === name) || null
        },
        async search(isPagination = false) {
            this.setOnLoad(true);

            let searchFilters = {}
            searchFilters['facet'] = {}

            for (const property in this.currentFilters) {
                if (property == "nomrevues"){
                    searchFilters['nomrevues'] = this.currentFilters[property]
                } else {
                    if (Array.isArray(this.currentFilters[property])) {
                        searchFilters['facet'][property] = this.currentFilters[property]
                    } else {
                        if (this.currentFilters[property] != null) {
                            searchFilters[property] = this.currentFilters[property]
                        }
                    }
                }
            }

            this.$api4d.getRecherche(this.auth.token, searchFilters).then(({ data }) => {
                this.processResults(data.data);

                this.totalPages = Math.round(this.result.total / this.perPage);

                if (!isPagination) {
                    this.currentPage = 1;
                }

                if (this.currentFilters.nomrevues.length > 0 || this.currentFilters.motcle.length > 0 || this.currentFilters.specialite.length > 0) {
                    this.showDeleteFilters = true
                } else {
                    this.showDeleteFilters = false
                }

                this.setOnLoad(false);
                this.$emit('watchRefresh');
                this.scrollToElement();
            }).catch((e) => {
                this.showDeleteFilters = false
                this.setOnLoad(false);
                console.log(e)
            })
        },
        processResults(res){
            const userType = this.getProfile.user_type;
            const checkAbonnementIndividuel = (abonnement_revue, datePublication) => {
                return abonnement_revue.some(abonnement => {
                    if (abonnement.inProgress) {
                        return true;
                    } else {
                        return abonnement.period.some(item =>
                            moment(datePublication).isBetween(item.start_date, item.end_date)
                        );
                    }
                })
            };
            res.results.forEach(element => {
                let revue = element.nomrevue;
                if (element.nomrevue == "Concours pluripro" || element.nomrevue == "Le Concours médical") {
                    revue = "Le Concours Pluripro";
                }
                let date_publication = moment(element.date_publication).format('YYYY-MM-DD');
                let abonnement_revue = this.getAbonnements.filter(f => f.key === revue);
                if (abonnement_revue.length > 0) {
                    if (userType === 'Institutionnel') {
                        element.isAbonne = true;
                    } else {
                        element.isAbonne = checkAbonnementIndividuel(abonnement_revue, date_publication);
                    }
                }
            })

            this.result = res
            this.totalPages = Math.ceil(res.total / this.perPage)
        },
        getDate(value) {
            return moment(value).format('DD/MM/YYYY');
        },
        onPageChange(page) {
            this.currentFilters.offset = (page - 1) * this.perPage;
            this.currentPage = page
            this.search(true)
        },
        onSelect() {
            this.setSearchFilters(this.currentFilters);
            this.search()
        },
        onSelectRevue() {
            /*if (this.currentFilters.nomrevue.length > 0) {
                this.currentFilters.nomrevue = [event.target.value];
            }*/
            this.setSearchFilters(this.currentFilters);
            this.search()
        },
        toggleShow(item) {
            if (item == 'specialite') {
                this.showFacetSpecialite = !this.showFacetSpecialite
            }
            if (item == 'motcle') {
                this.showFacetMotCle = !this.showFacetMotCle
            }
            if (item == 'revue') {
                this.showFacetRevue = !this.showFacetRevue
            }
            if (item == 'filter') {
                this.showFilter = !this.showFilter;
            }
        },
        downloadPDF(e) {
            this.setOnLoad(true);
            const id = e.currentTarget.dataset.id;
            const title = e.currentTarget.dataset.title;
            const current_revue = e.currentTarget.dataset.revue;

            this.$api.postActivity({
                token: this.auth.token,
                category: 'downloadPdf',
                action: 'clic téléchargement',
                label: id + ' : ' + title,
                content_title: title,
                revue: current_revue
            });

            this.$api4d.getBinairePdf(this.auth.token, id).then((data) => {
                let blob = data.data;
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = title + ".pdf";
                link.click();
                this.setOnLoad(false);
            })
            .catch(e => {
                this.setOnLoad(false);
                console.log(e);
            });
        },
        viewPdf(e) {
            this.setOnLoad(true);
            const id = e.currentTarget.dataset.id;
            const title = e.currentTarget.dataset.title;
            const current_revue = e.currentTarget.dataset.revue;

            this.$api.postActivity({
                token: this.auth.token,
                category: 'viewPdf',
                action: 'clic visualisation',
                label: id + ' : ' + title,
                content_title: title,
                revue: current_revue
            });

            this.$api4d.getBinairePdf(this.auth.token, id).then((data) => {
                const blob = new Blob([data.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const win = window.open(url, '_blank');


                win.document.write(`
  <!DOCTYPE html>
  <html>
    <head>
      <title>${title}</title>
      <style>
        html, body {
          margin: 0;
          height: 100%;
        }
        iframe {
          width: 100%;
          height: 100%;
          border: none;
        }
      </style>
    </head>
    <body>
      <iframe src="${url}"></iframe>
    </body>
  </html>
`)

                this.setOnLoad(false);
                setTimeout(() => window.URL.revokeObjectURL(url), 10000);
            })
            .catch(e => {
                this.setOnLoad(false);
                console.log(e);
            });
        },
        showPopinExport(id, title) {
            this.popin.id = id;
            this.popin.title = title;
            this.showPopin = true;
        },
        closePopinExport() {
            this.popin.id = null;
            this.popin.title = null;
            this.showPopin = false;
        },
        exportFormat(e, type) {
            this.setOnLoad(true);
            const id = this.popin.id;
            const title = this.popin.title;
            let article = this.result.results.filter(f => f.id === id);
            if (article.length > 0) {
                article = article[0];

                this.$api.postActivity({
                    token: this.auth.token,
                    category: 'exportReference',
                    action: 'export ' + type.toUpperCase(),
                    label: id + ' : ' + title,
                    content_title: title,
                    revue: article.nomrevue
                });

                this.$api.postExportFormat({
                    token: this.auth.token,
                    article: article,
                    type: type
                }).then((data) => {
                    let blob = data.data;
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = title + '.' + type;
                    link.click();
                    this.setOnLoad(false);
                })
                .catch(e => {
                    this.setOnLoad(false);
                    console.log(e);
                });
            } else {
                this.setOnLoad(false);
            }
        },
        resetFilters() {
            this.defaultFilters();
            this.search();
        },
        defaultFilters(all = true) {
            this.currentFilters.offset = 0;
            if (all) {
                this.currentFilters.rubrique = [];
                this.currentFilters.specialite = [];
                this.currentFilters.annee_debut = null;
                this.currentFilters.annee_fin = null;
                this.currentFilters.annee_parution = null;
                this.currentFilters.documentId = '';
                this.currentFilters.annee_debut = null;
                this.currentFilters.motcle = [];
                this.currentFilters.nomrevues = [];
                this.currentFilters.num_revue = null;
                this.currentFilters.sort = '';
            }
        },
        scrollToElement() {
            const container = document.getElementById('result-bloc');
            container.scrollIntoView({ behavior: 'smooth' });
        },
        trimChapo(text) {
            if (!text) return '';
            if (text.length <= 400) return text;

            // Trim the text at 400 characters but avoid breaking words
            let trimmedText = text.substr(0, 400);
            let lastSpace = trimmedText.lastIndexOf(' ');

            if (lastSpace > 0) {
                trimmedText = trimmedText.substr(0, lastSpace);
            }

            return `${trimmedText}...`; // Add ellipsis at the end
        }
    },
    created() {
        this.currentFilters = this.getSearchFilters
        this.search()
    },
    beforeUnmount() {
        this.defaultFilters(false);
        this.setSearchFilters(this.currentFilters);
    }
}
</script>
<style lang="scss" scoped>
@import "@/scss/helpers/mixins";
    @import "@/scss/helpers/variables";

.result-reponse {
    padding-bottom: 72px;
    padding-top: 45px;
    background-color: #F5F5F5;

    @include min($lg) {
        padding-top: 60px;
    }
}

.result-list--btn {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    @media screen and (max-width:768px) {
        flex-direction: row-reverse;
        justify-content: space-between;
    }

    > * {
        margin: 0 10px 0 0;
    }
}

.result-filter-wrapper {
    max-height: 0;
    overflow: hidden;
    transition: max-height 500ms;

    &.is-active-filters {
        max-height: 3000px;
    }

    @include min($lg) {
       max-height: inherit;
       overflow: visible;
    }
}

.resultes-reponses-wrapper {
    margin-left: -12px;
    margin-right: -12px;

    @include min($lg) {
        display: flex;
        align-items: flex-start;
    }

    > div {
        padding-left: 12px;
        padding-right: 12px;
    }

    .result-filter {
        width: 100%;
        background: #EEEEEE 0% 0% no-repeat padding-box;
        box-shadow: inset 0px 3px 3px #2838611A;
        border-radius: 30px;
        padding: 15px;
        margin-bottom: 14px;

        @include min($lg) {
            width: 313px;
            flex: 0 0 313px;
        }

        &__heading {
            margin: 0 0 19px;
            font-family: $campaign;
            font-size: 15px;
            font-weight: $medium;
            line-height: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: $main;

            // &:before {
            //     content: "";
            //     width: 22px;
            //     height: 22px;
            //     background: url("@/assets/images/filtres.svg") 0 0 no-repeat transparent;
            //     display: block;
            //     margin-right: 10px;
            // }

            svg {
                width: 22px;
                height: 22px;
                display: block;
                margin-right: 10px;
            }
        }

        .title {
            text-align: center;
        }
    }

    .result-bloc {
        width: -webkit-fill-available;
        scroll-margin: 130px;

        &__header {
            width: 100%;
            margin: 0 0 10px;
            text-align: center;

            @include min($lg) {
                margin: 0 0 30px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                text-align: left;
            }
        }

        &__heading {
            margin: 0 0 19px;

            @include min($lg) {
                margin: 0;
            }
        }

        &-header {
            display: flex;
            justify-content: space-between;
            align-items: center;

            &__heading {
                margin: 0;
                background: $inputgray 0% 0% no-repeat padding-box;
                box-shadow: inset 0px 3px 3px #2838611A;
                height: 40px;
                width: auto;
                padding: 0 19px;
                border-radius: 25px;
                display: inline-flex;
                align-items: center;
                cursor: pointer;

                &.focus {
                    background: $main;
                    color: $white;

                    svg {
                        path {
                            stroke: $white;
                        }
                    }
                }
            }
        }
    }

    .result-list {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        border-radius: 30px;
        padding: 20px 20px;
        margin: 1rem auto;
        word-wrap: break-word;

        @include min($lg) {
            padding: 20px 30px;
        }

        &:first-child {
            margin: 0 auto 1rem;
        }

        h4 {
            margin: 0 0 10px;
            font-family: $campaign;
            font-size: 15px;
            font-weight: $bold;
            line-height: 20px;
        }

        p {
            font-size: 16px;
        }

        .revue__detail {
            margin-bottom: 10px;

            p, .author {
                font-size: 12px;
                line-height: 15px;
                margin: 0;
            }
        }
    }

    .btn-download {
        margin: 0 10px 0 0;
        font-size: 0;
        padding: 0 40px;
        display: flex;
        align-items: center;

        @include min($lg) {
            font-size: 15px;
            padding: 12px 28px;
        }

        svg {
            @include min($lg) {
                display: none
            }
        }
    }
}

.btn-export {
    flex: 1;

    @include min($sm) {
        flex: inherit;
    }
}

.result_popin {
    position: fixed;
    top:0;
    right:0;
    left: 0;
    bottom: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,.7);

    &__wrapper {
        background-color: white;
        padding: 40px 40px;
        border-radius: 30px;

        .result_popin__content {
            margin-top: 20px;
            display: block;

            @include min($sm) {
                display: flex;
                gap: 20px;
            }

            .btn-export {
                display: block;
                margin: 10px auto;

                @include min($sm) {
                    margin: 0;
                }
            }
        }

        .result_popin__header {
            position: relative;
            .popin_close {
                position: absolute;
                top: -20px;
                right: -20px;
                cursor: pointer;
                &::before {
                    content: "";
                    display: block;
                    background: url('@/assets/images/close\ icon.png') no-repeat center;
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }

}

.reset-filters {
    text-align: center;
    margin-bottom: 10px;
    font-size: 12px;
    color: $red;

    span {
        cursor: pointer;
    }
}
</style>